<template>
  <div id="app">
    <HelloWorld  msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import "@/assets/font/font.css"
import { Application } from '@splinetool/runtime';
export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
* {
  font-family: 'HarmonyOS Font';
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
